<template>
  <div class="cadastro-container">
    <div class="cadastro-card">
      <h1>Cadastro de Usuário</h1>
      <p class="subtitle">Crie sua conta no Portal de Honorários</p>
      
      <form @submit.prevent="handleCadastro" class="cadastro-form">
        <div class="form-group">
          <label for="nome">Nome</label>
          <input 
            type="text" 
            id="nome" 
            v-model="usuario.nome" 
            required
            placeholder="Digite seu nome"
          >
        </div>
        
        <div class="form-group">
          <label for="sobrenome">Sobrenome</label>
          <input 
            type="text" 
            id="sobrenome" 
            v-model="usuario.sobrenome" 
            required
            placeholder="Digite seu sobrenome"
          >
        </div>
        
        <div class="form-group">
          <label for="email">Email</label>
          <input 
            type="email" 
            id="email" 
            v-model="usuario.email" 
            required
            placeholder="Digite seu email"
          >
        </div>
        
        <div class="form-group">
          <label for="telefone">Telefone</label>
          <input 
            type="tel" 
            id="telefone" 
            v-model="usuario.telefone" 
            required
            placeholder="Digite seu telefone"
          >
        </div>
        
        <div class="form-group">
          <label for="senha">Senha</label>
          <input 
            type="password" 
            id="senha" 
            v-model="usuario.senha" 
            required
            placeholder="Digite sua senha"
          >
        </div>
        
        <div class="form-actions">
          <button type="submit" class="btn btn-primary">
            <i class="fas fa-user-plus"></i> Cadastrar
          </button>
          <button type="button" class="btn btn-secondary" @click="voltarLogin">
            <i class="fas fa-arrow-left"></i> Voltar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'Cadastro',
  setup() {
    const router = useRouter()
    
    const usuario = ref({
      nome: '',
      sobrenome: '',
      email: '',
      telefone: '',
      senha: ''
    })
    
    const handleCadastro = () => {
      // Simulação de cadastro
      alert('Usuário cadastrado com sucesso!')
      router.push('/')
    }
    
    const voltarLogin = () => {
      router.push('/')
    }
    
    return {
      usuario,
      handleCadastro,
      voltarLogin
    }
  }
}
</script>

<style scoped>
.cadastro-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  padding: 20px;
}

.cadastro-card {
  background-color: var(--bg-primary);
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 10px 30px var(--shadow);
  width: 100%;
  max-width: 500px;
  text-align: center;
}

.cadastro-card h1 {
  color: var(--text-primary);
  margin-bottom: 10px;
  font-size: 28px;
}

.subtitle {
  color: var(--text-secondary);
  margin-bottom: 30px;
  font-size: 14px;
}

.cadastro-form {
  text-align: left;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.form-actions .btn {
  flex: 1;
}

@media (max-width: 640px) {
  .cadastro-container {
    padding: 16px;
    align-items: flex-start;
  }

  .cadastro-card {
    padding: 24px 18px;
    border-radius: 18px;
    margin: auto 0;
  }

  .cadastro-card h1 {
    font-size: 24px;
  }

  .form-actions {
    flex-direction: column;
  }
}
</style>
